'use client';

import { PageHeader } from '@/slw/widgets/contact/page-header';
import { CompanyInfoCard } from '@/slw/widgets/contact/company-info-card';
import { InteractiveMap } from '@/slw/widgets/contact/interactive-map';
import { HelpCenterSection } from '@/slw/widgets/contact/help-center-section';
import { FeedbackForm } from '@/slw/widgets/contact/feedback-form';
import { Breadcrumb } from '@/slw/widgets/common/breadcrumb.ui';

export function ContactPage() {
  const breadcrumbs = [{ name: 'Contact Us' }];

  return (
    <main className='mb-20'>
      <div className='container mx-auto px-8 lg:px-16 2xl:px-0'>
        <Breadcrumb data={breadcrumbs} />
        <PageHeader />
      </div>
      <div className='container mx-auto px-8 lg:px-16 2xl:px-0'>
        <div
          className='lg:mt-20 md:mt-10 mt-6 grid grid-cols-1 md:grid-cols-[auto_1fr]  
      lg:grid-cols-[minmax(0,20rem)_1fr] md:gap-8'
        >
          <CompanyInfoCard />
          <InteractiveMap />
        </div>
      </div>
      <div className='w-full lg:my-20 md:my-10 my-6 bg-[#F7F7F9] rounded-2xl'>
        <div className='container mx-auto px-8 lg:px-16 2xl:px-0'>
          <HelpCenterSection />
        </div>
      </div>
      <div className='container mx-auto px-8 lg:px-16 2xl:px-0'>
        <div className='lg:mt-20 md:mt-10 mt-6'>
          <FeedbackForm />
        </div>
      </div>
    </main>
  );
}
